<script>
import { cloneDeep, filter } from 'lodash-es';

export default {
  name: 'ItineraryDayProgramExcursionModal',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    dayProgram: {
      type: Object,
      default: () => {},
    },
    availableExtras: {
      type: Array,
      default: () => [],
    },
    countriesAndAreas: {
      type: Array,
      default: () => [],
    },
    itineraryId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      twentyUrl: `${process.env.TWENTY_FRONT_PAGE}/support-system/extra`,
      toggled: true,
      search: '',
      selectedAreaId: null,
      headers: [
        { text: '#', align: 'left', value: 'id' },
        { text: this.$t('itinerary.excursionModal.table.name'), align: 'left', value: 'description' },
        { text: this.$t('itinerary.excursionModal.table.supplier'), align: 'left', value: 'supplier.name' },
        { text: this.$t('itinerary.excursionModal.table.inclusive'), align: 'center', sortable: false },
        { text: this.$t('itinerary.excursionModal.table.optional'), align: 'center', sortable: false },
      ],
      pagination: {
        rowsPerPage: 25,
        descending: false,
        sortBy: 'name',
      },
      extras: [],
    };
  },
  methods: {
    update() {
      this.$emit('update', {
        itineraryId: this.itineraryId,
        dayProgramId: this.dayProgram.id,
        extras: this.extras,
      });
    },
    customFilter(items) {
      const search = this.search.toString().toLowerCase();
      return items.filter((i) => {
        const supplierName = i.supplier.name.toLowerCase();
        const description = i.content.description.toLowerCase();
        const searchBool =
          !search || (supplierName.indexOf(search) !== -1 || description.indexOf(search) !== -1);
        const selectBool = !this.selectedAreaId || i.areaIds.indexOf(`${this.selectedAreaId}`) !== -1;
        return searchBool && selectBool;
      });
    },
  },
  watch: {
    toggled(value) {
      if (!value) {
        this.$emit('cancel');
      }
    },
    availableExtras(value) {
      this.extras = cloneDeep(value);
    },
  },
  computed: {
    getAreasByDayProgramCountryId() {
      const country = filter(this.countriesAndAreas, ca => ca.id === this.dayProgram.countryId);
      return country[0].areas;
    },
  },
  created() {
    this.extras = cloneDeep(this.availableExtras);
  },
};
</script>

<template>
  <v-dialog
    v-model="toggled"
    max-width="800px"
  >
    <v-card>
      <v-flex font-weight-bold pa-3 title>
        <v-icon>directions_walk</v-icon>
        <span>Assign extra excursions / transfers to day program entry</span>
      </v-flex>
      <v-divider light/>
      <v-layout row>
        <v-flex md5>
          <v-text-field
            v-model="search"
            class="px-4"
            clear-icon="clear"
            append-icon="search"
            :loading="loading"
            :label="$t('inputs.placeholders.search')"
          />
        </v-flex>
        <v-flex md5>
          <v-select
            v-model="selectedAreaId"
            :items="getAreasByDayProgramCountryId"
            item-text="name"
            item-value="id"
            label="Filter by area"
            clearable
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-progress-linear
            v-if="loading"
            class="my-0"
            :active="loading"
            :indeterminate="true"
            :height="4"
          />
          <v-data-table
            class="elevation-1"
            :headers="headers"
            :items="extras"
            :loading="loading"
            :pagination.sync="pagination"
            :search="search"
            :custom-filter="customFilter"
          >
            <template v-slot:items="props">
              <td>{{ props.item.id }}</td>
              <td>
                <a
                  target="_blank"
                  :href="`${ twentyUrl }/${ props.item.id }/edit`"
                >
                  {{ props.item.content.description }}
                </a>
              </td>
              <td>{{ props.item.supplier.name }}</td>
              <td>
                <v-checkbox
                  v-model="props.item.type"
                  hide-details
                  value="included"
                  class="justify-center"
                />
              </td>
              <td>
                <v-checkbox
                  v-model="props.item.type"
                  hide-details
                  value="optional"
                  class="justify-center"
                />
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <v-layout justify-end>
        <v-btn
          color="red darken-1"
          flat
          @click="toggled = false"
        >
          {{ $t('inputs.actions.cancel') }}
        </v-btn>
        <v-btn
          :disabled="loading"
          :loading="loading"
          color="blue darken-1"
          flat
          @click="update"
        >
          {{ $t('inputs.actions.save') }}
        </v-btn>
      </v-layout>
    </v-card>
  </v-dialog>
</template>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryDayProgramExcursionModal.vue